module.exports = __webpack_public_path__ + "img/JBI_subscription_Header_image.85cca75c.png";